import { render, staticRenderFns } from "./ItemFormTable.vue?vue&type=template&id=6e23e8cf&"
import script from "./ItemFormTable.vue?vue&type=script&lang=js&"
export * from "./ItemFormTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemFormTable.vue?vue&type=style&index=0&id=6e23e8cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports